import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import { useSelector, RootStateOrAny } from "react-redux";
import { containerS } from "../../../styles/containerStyles";
import OrderBasicInfo from "./OrderBasicInfo";
import CommentInput from "../CommentInput";
import PaymentMethod from "./PaymentMethod";
import Prices from "../PricesEdit";
import OrderParams from "../newOrder/OrderParams";
import NewFormBtns from "../../../../common/layout/form/NewFormBtns";
import { useOrderDetails } from "../../../hooks/useOrderDetailsForm";
import ActivityIndicator from "../../../../common/layout/ActivityIndicator";
import MessageContainer from "../../../../auth/components/register/forms/MessageContainer";
import FormDropDownReception from "../../../../common/layout/form/FormDropDownReception";

const OrderDetailsFrom: React.FC = () => {
  const { t } = useTranslation("admin");
  const { orderDetails } = useSelector((state: RootStateOrAny) => state.orderPanel);

  const [reception, setReception] = useState<any>({key: undefined});
  const [orderTypeItemId, setOrderTypeItemId] = useState<any>({name: ""});

  const {
    receptionPlaces,
    orderTypeItems,
    handleSubmit,
    cancelForm,
    initValues,
    isLoading,
    changePrice, 
    orderType
  } = useOrderDetails(reception);
  
    const [price, setPrice] = useState<number>(orderDetails.netPrice);

    useEffect(() => {
        if (orderDetails && orderDetails.netPrice) {
            setPrice(orderDetails.netPrice);
        }
    }, [orderDetails]);

    // Ref do setFieldValue żeby móc go używać w useEffect
    const setFieldValueRef = useRef<any>(null);

    // Synchronizuj lokalny price z Formik
    useEffect(() => {
        if (setFieldValueRef.current && price) {
            setFieldValueRef.current('netPrice', price);
        }
    }, [price]);
    //merge from master
  if(reception === 0 && initValues !== undefined && initValues.receptionPlace !== "") {
    setReception(orderDetails.receptionPlaceId);
    setOrderTypeItemId(orderDetails.orderTypeItemId);
    //setPrice(orderDetails.netPrice);
    //setBrutto(orderDetails.)
  }

  // const [receptionPlace] = useField("receptionPlace")
  // const [orderTypeItemId] = useField("orderTypeItemId")

  return (
    <div className={containerS}>
      <OrderBasicInfo activeOrder={orderDetails} />
      <Formik
        enableReinitialize={true}
        initialValues={initValues}
        onSubmit={handleSubmit}
        validateOnChange={false}
        validateOnBlur={false}
      >
        {({ values, setFieldValue, handleChange }) => {         
          setFieldValueRef.current = setFieldValue;

          return (
          <Form>
            <FormDropDownReception
              name="receptionPlace"
              headerText={t("nav.panelPickupPoint")}
              options={receptionPlaces}
              onChange={changePrice}
              setReception={setReception}
              orderTypeItemId={orderTypeItemId}
              //setPrice={setPrice}
              //changePrice={changePrice}
            />
            <CommentInput
              value={initValues.additionalInfo ? initValues.additionalInfo : ""}
              name="additionalInfo"
              onChange={handleChange}
              label={t("nav.additionalInfo")}
            />
            <OrderParams
              headerText={t("nav.panelDetails")}
              orderType={orderType}
              setFieldValue={setFieldValue}
              values={values}
              items={orderTypeItems}
              setPrice={setPrice}
              onChange={changePrice}
              setOrderTypeItemId={setOrderTypeItemId}
              reception={reception}
              price={price}
            />
            <PaymentMethod setFieldValue={setFieldValue} paymentType={orderDetails.paymentType} />
            <Prices 
              value={price !== null ? price : orderDetails.netPrice}
              setPrice={setPrice}
              disabled={price ? false : true}
              orderTypeId={Number(orderDetails.orderTypeId)}
            />
            <NewFormBtns positionAbsolute={true} submitBtnText={t("nav.save") as string} cancelForm={cancelForm} disabled={isLoading} disabledOnlySubmitButton={!price}/>
            {isLoading ? <ActivityIndicator/> : <MessageContainer/>}
          </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default OrderDetailsFrom;